import React, { FunctionComponent } from 'react';
import styles from './social-media-panel.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLinkedin,
  faGithub,
  faFacebook
} from '@fortawesome/free-brands-svg-icons';

export interface ISocialMediaPanelProps {
  linkedinUrl: string;
  githubUrl: string;
  facebookUrl: string;
}

export const SocialMediaPanel: FunctionComponent<ISocialMediaPanelProps> = ({
  linkedinUrl,
  githubUrl,
  facebookUrl
}) => {
  return (
    <div className={styles.wrapper}>
      <a
        href={linkedinUrl}
        className={styles.icon}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faLinkedin} />
      </a>
      <a
        href={githubUrl}
        className={styles.icon}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faGithub} />
      </a>
      <a
        href={facebookUrl}
        className={styles.icon}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faFacebook} />
      </a>
    </div>
  );
};
